var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalWaronTerrorismExpeditonary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 0H378V250H273V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    width: 105,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593,
    width: 57,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    width: 105,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    width: 35,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    width: 30,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413,
    width: 35,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 40,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553,
    width: 40,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    width: 40,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483,
    width: 40,
    height: 250,
    fill: "#00155C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalWaronTerrorismExpeditonary);
export default __webpack_public_path__ + "static/media/Global War on Terrorism Expeditonary.0d528ed3d10718a3e25fe86be044a3db.svg";
export { ForwardRef as ReactComponent };